export default __webpack_public_path__ + "static/media/Ballroll_00055.acec908c.png";